module.exports = __webpack_public_path__ + "static/media/security-type.35dc8437.svg";